var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3431_55918)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 72,
    r: 60,
    fill: "#38879F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.9609 74.1365H83.0827C84.2525 74.1365 85.2173 73.1716 85.2173 72.0019C85.2173 70.8322 84.2525 69.8673 83.0827 69.8673H69.9609V61.5404C69.9609 58.1586 71.0156 55.462 72.8658 53.6119C74.7159 51.7617 77.4125 50.707 80.7943 50.707H86.4609C89.8428 50.707 92.5392 51.7617 94.3865 53.6116C96.2337 55.4614 97.283 58.1575 97.2725 61.5388V61.5404V82.4634C97.2725 85.8452 96.2178 88.5418 94.3676 90.3919C92.5175 92.2421 89.8209 93.2968 86.4391 93.2968H80.7943C77.4125 93.2968 74.7159 92.2421 72.8658 90.3919C71.0156 88.5418 69.9609 85.8452 69.9609 82.4634V74.1365Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4314 70.0126L58.5779 70.8661H59.785H68.9619V73.1354H59.785H58.5779L59.4314 73.9889L63.943 78.5005C64.3798 78.9373 64.3798 79.6668 63.943 80.1036C63.5062 80.5404 62.7766 80.5404 62.3398 80.1036L55.0385 72.8023C54.6017 72.3655 54.6017 71.636 55.0385 71.1992L62.3398 63.8979C62.7766 63.4611 63.5062 63.4611 63.943 63.8979L63.9491 63.904L63.9554 63.9099C64.1647 64.1053 64.276 64.4 64.276 64.6995C64.276 64.9881 64.1712 65.2728 63.943 65.5011L59.4314 70.0126Z",
    fill: "white",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3431_55918",
    x: 0,
    y: 0,
    width: 152,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3431_55918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3431_55918",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutModalIcon);
export default __webpack_public_path__ + "static/media/logout-modal-icon.58afb9860fb4780e9929a0c742e05a09.svg";
export { ForwardRef as ReactComponent };